import { render, staticRenderFns } from "./ParamAdd.vue?vue&type=template&id=613885ca&scoped=true"
import script from "./ParamAdd.vue?vue&type=script&lang=js"
export * from "./ParamAdd.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "613885ca",
  null
  
)

export default component.exports